export const THEME_TYPES = {
  DARK: "dark",
  LIGHT: "light",
  SYSTEM: "system",
  CUSTOM_LIGHT: "customLight",
  CUSTOM_DARK: "customDark"
};

export const THEME_COLORS = {
  DARK: {
    PRIMARY_BG: "#010409", // 05111f
    SECONDARY_BG: "#0e141b", // 1e283e
    PRIMARY_FONT: "#ecedefff",
    SECONDARY_FONT: "#bfc1c4ff",
    SELECTED_BG: "#47494cff",
    NODE_BORDER: "#2D3748",
    INPUT_BG: "#25272b",
    DISABLED_BG: "#212830", //454d62
    NAVBAR_BG: "#10151b",
    ACTIVE_NAVBAR_BG: "#3233348a"
  },
  LIGHT: {
    PRIMARY_BG: "#F2F6F9",
    SECONDARY_BG: "#FFFFFF",
    PRIMARY_FONT: "#1E283E",
    SECONDARY_FONT: "#8392ab",
    SELECTED_BG: "#E2E8F0",
    NODE_BORDER: "#E2E8F0",
    INPUT_BG: "#FFFFFF",
    DISABLED_BG: "#E9ECEF",
    NAVBAR_BG: "#FFFFFF",
    ACTIVE_NAVBAR_BG: "#E2E8F0"
  }
};
